// components/Features.jsx
import React from "react";
import "./Features.css";
import {
  Zap,
  BarChart3,
  Smartphone,
  Shield,
  Package,
  Users,
} from "lucide-react";

const Features = () => {
  const features = [
    {
      icon: <Zap size={28} />,
      title: "Lightning Fast Billing",
      description:
        "Process orders and generate bills in seconds. Touch-optimized interface designed for high-volume peak hours with KOT and kitchen display support.",
      color: "#f97316",
    },
    {
      icon: <BarChart3 size={28} />,
      title: "Real-time Analytics",
      description:
        "Live dashboards showing sales trends, top products, revenue per outlet, tax reports, and staff performance — all updated in real time.",
      color: "#3b82f6",
    },
    {
      icon: <Smartphone size={28} />,
      title: "Multi-device Ready",
      description:
        "Works seamlessly on tablets, phones, and desktops. Cloud-based means you can manage your business from anywhere, anytime.",
      color: "#8b5cf6",
    },
    {
      icon: <Shield size={28} />,
      title: "Role-Based Access",
      description:
        "Define roles and permissions for cashiers, managers, and owners. Track every action with complete audit trails and user right management.",
      color: "#22c55e",
    },
    {
      icon: <Package size={28} />,
      title: "Smart Inventory",
      description:
        "Track raw materials, set low-stock alerts, manage recipes, monitor wastage, and handle central kitchen restocking — all automated.",
      color: "#ec4899",
    },
    {
      icon: <Users size={28} />,
      title: "Customer CRM",
      description:
        "Build loyalty programs, track purchase history, send SMS marketing, collect feedback, and manage customer wallets for repeat business.",
      color: "#06b6d4",
    },
  ];

  return (
    <section id="features" className="section features-section">
      <div className="container">
        <h2 className="section-title">
          Everything You Need to{" "}
          <span className="gradient-text">Run & Grow</span>
        </h2>
        <p className="section-subtitle">
          Powerful tools designed for every aspect of your food business — from
          billing to analytics, inventory to customer management.
        </p>

        <div className="features__grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="features__card glass-card"
              style={{ "--card-accent": feature.color }}
            >
              <div className="features__icon">{feature.icon}</div>
              <h3 className="features__card-title">{feature.title}</h3>
              <p className="features__card-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;